import { render, staticRenderFns } from "./Action_alert_iframe.vue?vue&type=template&id=39c4555a&scoped=true&"
import script from "./Action_alert_iframe.vue?vue&type=script&lang=js&"
export * from "./Action_alert_iframe.vue?vue&type=script&lang=js&"
import style0 from "./Action_alert_iframe.vue?vue&type=style&index=0&id=39c4555a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c4555a",
  null
  
)

export default component.exports